<template>
  <div class="mw-split-container mw-bar-data inner-view">
    <split-pane :defaultSize="216" split="vertical">
      <template slot="paneL">

      <mw-dialog ref="leadDialog" title="导出管理日志excel" size="mini_mini" :footerButton="leadButton">
       <div class="mw-toolbar_body inner-toolbar__body" style="margin-top:20px;">
          <el-form label-width="100px">
            <el-col :span="24">
              <el-form-item label="开始时间">
                <template>
                  <el-date-picker
                    v-model="startDate"
                    type="datetime"
                    placeholder="选择日期"
                    :picker-options="pickerBeginDateBefore">
                  </el-date-picker>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="结束时间">
                <template>
                    <el-date-picker
                    v-model="finishDate"
                    type="datetime"
                    placeholder="选择日期"
                    :picker-options="pickerBeginDateAfter">
                  </el-date-picker>
                </template>
              </el-form-item>
            </el-col>

          </el-form>
       </div>
      </mw-dialog>

      <mw-dialog ref="findDialog" title="查询" width="754" class="log-query-dlg log-query-dlg-operation"  :footerButton="findButton">
       <div class="mw-toolbar_body inner-toolbar__body">
          <el-form label-width="120px">
            <el-col :span="12">
              <el-form-item label="操作开始时间">
                <template>
                  <el-date-picker
                    v-model="findOptions.createTime"
                    type="datetime"
                    placeholder="选择日期"
                   >
                  </el-date-picker>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="操作结束时间">
                <template>
                    <el-date-picker
                    v-model="findOptions.finishTime"
                     type="datetime"
                    placeholder="选择日期">
                  </el-date-picker>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="操作人">
                <template>
                    <el-input  v-model="findOptions.userName"></el-input>
                </template>
              </el-form-item>
            </el-col>


            <el-col :span="12">
              <el-form-item label="操作对象">
                <template>
                    <el-input v-model="findOptions.name"></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="操作类型">
                <template>
                    <el-input v-model="findOptions.type"></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="操作目标">
                <template>
                    <el-input v-model="findOptions.target"></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12" style="padding-bottom: 10px;">
              <el-form-item label="操作说明">
                <template>
                  <el-input v-model="findOptions.remark"></el-input>
                </template>
              </el-form-item>
            </el-col>

          </el-form>
       </div>
      </mw-dialog>

      <mw-dialog ref="editDialog" title="查看信息" size="large_large">
       <div class="mw-toolbar">
          <el-button  type="primary" @click="closeEditDialog"><i class="fa fa-mail-reply "></i> 关闭</el-button>
        </div>
       <div class="mw-toolbar__body">
          <el-form label-width="100px">
            <el-col :span="12">
              <el-form-item label="操作时间">
                <template>
                  <el-input v-model="form.createTime"  readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="操作人">
                <template>
                    <el-input v-model="form.userName" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="操作对象">
                <template>
                    <el-input v-model="form.name" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="操作类型">
                <template>
                    <el-input v-model="form.type" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="操作目标">
                <template>
                  <el-input v-model="form.target" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>
             <el-col :span="20">
              <el-form-item label="操作说明">
                <template>
                    <el-input type="textarea"  :rows="10" style="width:96%;" v-model="form.remark" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

          </el-form>
       </div>
      </mw-dialog>

        <div class="mw-split-left">
          <div class="mw-toolbar">
            <el-button @click="expand"><i class="fa fa-angle-double-down" v-if="!btnNotShowIcon"></i>展开</el-button>
            <el-button @click="closed"><i class="fa fa-angle-double-up" v-if="!btnNotShowIcon"></i>折叠</el-button>
          </div>

          <div class="mw-toolbar__body">
            <mw-tree :url="dictTreeUrl" :async="false" :multiple="false"  :selectFirst="true" :defaultParams="params && params.requestParams"
                   :expandedFirst="true"   @changed="loadTableTree" ref="dictTree">
            </mw-tree>
          </div>

        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right" >

           <toolbar-table :layout="layout" :autoLoad="false" ref="dataTable"></toolbar-table>

        </div>
      </template>
    </split-pane>

  </div>
</template>
<script>
import token from "@/common/utils/token";
export default {
  components: {

  },
  props: {
    params: {
      type: Object
    }
  },

  data() {
    let me = this;
    return {
      layout: [],
      headers: {},
      btnNotShowIcon:(window.$Env && $Env.btnNotShowIcon),
      dictTreeUrl: this.mwUrl("/api/business/listOperationTree"),
      selectNode: "",
      finishDate: '',
      startDate: '',
      leadButton: [
        {
          label: "确定",
          func: this.leadSure
        }, {
          label: "取消",
          type: "default",
          func: this.closeLeadDialog
        }
      ],
      findButton: [
        {
          label: "确定",
          func:function(){
            let startTime=me.findOptions.createTime;
            let finishTime=me.findOptions.finishTime;
            if (startTime)
              me.findOptions.createTime=new moment(startTime).format("YYYY-MM-DD HH:mm:ss"); // me.format(createTime);
            else
              delete me.findOptions.createTime;
            if (finishTime)
              me.findOptions.finishTime=new moment(finishTime).format("YYYY-MM-DD HH:mm:ss"); // me.format(finishTime);
            else
              delete me.findOptions.finishTime;
            me.findOptions.start=0;
            me.findOptions.limit=10;
            if(!startTime && !finishTime){
              me.findOptions.id=me.selectNode;
            }

            if(me.params && me.params.requestParams && me.params.requestParams.includeUsers)
              me.findOptions.includeUsers = me.params.requestParams.includeUsers;
            if(me.params && me.params.requestParams && me.params.requestParams.excludeUsers)
              me.findOptions.excludeUsers = me.params.requestParams.excludeUsers;
            if(me.params && me.params.requestParams && me.params.requestParams.threeMemberType)
              me.findOptions.threeMemberType = me.params.requestParams.threeMemberType;
            if(me.params && me.params.requestParams && me.params.requestParams.notThreeMemberType)
              me.findOptions.notThreeMemberType = me.params.requestParams.notThreeMemberType;
            if(me.params && me.params.requestParams && me.params.requestParams.condition)
              me.findOptions.condition = me.params.requestParams.condition;
            if(me.params && me.params.requestParams && me.params.requestParams.excludeClientIP)
              me.findOptions.excludeClientIP = me.params.requestParams.excludeClientIP;
            me.mwRef("dataTable").refreshTableDefaultParams(me.findOptions);
            // me.mwRef("dataTable")._refreshTable();
            me.closeFindDialog();
          }
        }, {
          label: "取消",
          type: "default",
          func: this.closeFindDialog
        }
      ],
      api: "",
      form:{
      },
      //查询条件
      findOptions:{}
    };
  },

  mounted() {
    let me = this;
    me.headers.Authorization = token.getToken();
    let defaultParams = [];
    if(me.params && me.params.requestParams){
      defaultParams = me.params.requestParams;
    }
    me.layout = [
      [
        {
          span: 0,
          type: "menu",
          label: "操作日志",
          api: "business.listOperationLog",
          defaultParams:defaultParams,
          singleSelect: true,
          columns: [
            { type: "selection" },
            { prop: "createTime",
              label: "操作时间",width:120},
            { slot:{type:'href',func:me.edit},prop: "userName", label: "操作用户",width:90 },
            { prop: "userLoginId", label: "操作人账号",width:110 },
            { prop: "clientIP", label: "操作人IP",width:120 },
            { prop: "name", label: "操作对象",width:120,tooltip: true},
            { prop: "type", label: "操作类型",width:90 },
            { prop: "target", label: "操作目标",width:90 },
            {
              prop: "remark",
              label: "操作说明",
              tooltip: true
            },
            { label: "状态",width:55,formatter: function(data) {
                return "成功";
             }}
          ]
        },
        {
          span: 10,
          type: "button",
          items: [
            {
              label: "导出",
              icon: me.btnNotShowIcon ? '' : "fa fa-plus-square",
              func: me.lead
            },
            {
              label: "查询",
              icon: me.btnNotShowIcon ? '' : "fa fa-search",
              func: me.findInf
            }
          ]
        },
        {
          span: 6,
          type: "searchText",
          name: "name",
          tip:"操作说明",
          offset: 8
        }
      ]
    ];
    if(this.params && this.params.isSaveQueryLog==true)
      me.saveQueryLog();
  },

  methods: {

    loadTableTree(data) {
      this.selectNode = data.id;
      let params=_.assign({id:data.id},this.params && this.params.requestParams)
      this.mwRef("dataTable").refreshTableDefaultParams(params);
    },

    lead() {
      this.mwRef("leadDialog").show();
    },

    leadSure(){
      var me=this;
      if(!me.startDate && !me.finishDate){
        me.mwMsg("warning", '请选择开始时间或结束时间!');
        return;
      }
      var params={};
      if(me.startDate)
        params.startDate=new moment(me.startDate).format("YYYY-MM-DD HH:mm:ss");
      if(me.finishDate)
        params.finishDate=new moment(me.finishDate).format("YYYY-MM-DD HH:mm:ss");

      if(me.params && me.params.requestParams && me.params.requestParams.includeUsers)
        params.includeUsers = encodeURIComponent(me.params.requestParams.includeUsers);
      if(me.params && me.params.requestParams && me.params.requestParams.excludeUsers)
        params.excludeUsers = encodeURIComponent(me.params.requestParams.excludeUsers);
      if(me.params && me.params.requestParams && me.params.requestParams.threeMemberType)
        params.threeMemberType = encodeURIComponent(me.params.requestParams.threeMemberType);
      if(me.params && me.params.requestParams && me.params.requestParams.notThreeMemberType)
        params.notThreeMemberType = encodeURIComponent(me.params.requestParams.notThreeMemberType);
      if(me.params && me.params.requestParams && me.params.requestParams.excludeClientIP)
        params.excludeClientIP = encodeURIComponent(me.params.requestParams.excludeClientIP);
      if(me.params && me.params.requestParams && me.params.requestParams.condition)
        params.condition = encodeURIComponent(me.params.requestParams.condition);
      this.mwApi.business.expOperationLog(params);
      this.closeLeadDialog();
    },
    closeLeadDialog(){
       this.startDate="";
       this.finishDate="";
       this.mwRef("leadDialog").hide();
    },

    closeFindDialog(){
      //  this.findOptions.createTime="";
      // this.findOptions.finishTime="";
      this.findOptions = {};
      this.mwRef('findDialog').hide()
    },

    findInf(){
      this.mwRef("findDialog").show();
    },
    refresh() {
      this.mwRef("dictTree").refresh();
    },

    edit(row){
         this.mwApi.business.getOperationLog(row.id).then(res =>{
             this.mwRef('editDialog').show();
             this.form = res.result;
         })
    },

    editSure(){
      this.closeEditDialog();
    },
    closeEditDialog(){
      this.mwRef('editDialog').hide()
    },

    expand() {
      this.mwRef('dictTree').openAll();
    },
    closed() {
      this.mwRef('dictTree').closeAll();
    },
    format(date){
      if(!(date instanceof Date)){
        return '';
      }
      let year=date.getFullYear();
      let month=date.getMonth()+1;
      let day=date.getDate();
      let hour=date.getHours();
      let min=date.getMinutes();
      let second=date.getSeconds();
      month=(month>=10?"":"0")+month;
      day=(day>=10?"":"0")+day;
      hour=(hour>=10?"":"0")+hour;
      min=(min>=10?"":"0")+min;
      second=(second>=10?"":"0")+second;
      return year+"-"+month+"-"+day+" "+hour+":"+min+":"+second;
    },
    saveQueryLog() {
      var dataTable = this.mwRef("dataTable").mwRef("dataTable");
      var tableObj = this.mwRef("dataTable");
      tableObj.$on("dataLoaded", function (d) {
        var total = d ? d.length : 0;
        if (tableObj.isSearch) {
          var rm = "共查询到" + total + "条记录";
          var params = {
            flag: "列表查询",
            targetName: '日志管理-用户管理日志',
            remark: rm,
            objType: '日志',
            target: '功能',
            eventType: '三员管理操作',
            zycd: "一般",
            result: rm
          };
          PF.invoke("sys-log-service.saveOprLog", params);
        }
      })
    }

  },
  watch: {}
};
</script>
<style scoped>
.el-input {
  width: calc(100% - 5px);
}

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/log/operationLog.vue